export default __webpack_public_path__ + "static/Visiomate_Nurtureful_Case_Study-0e6b49fa6da40559a686ec9af04aaa7c.pdf";